<template>
  <div class="besupplier">
    <div class="title">
      升级为服务商<span class="tip"
        >（完善以下基本资料，即可升级为服务商）</span
      >
    </div>
    <el-form
      class="myaccount-supplierform"
      ref="basicsForm"
      :model="formData"
      label-position="left"
      label-width="100px"
      :rules="rules"
    >
      <div class="form-item form-item-base">
        <el-form-item label="ID:">
          <el-input
            :disabled="true"
            readonly
            class="custom-input txt-normalstyle width270"
            :value="
              formData && formData.id_public_user_info
                ? formData.id_public_user_info
                : ''
            "
          ></el-input>
        </el-form-item>
        <el-form-item label="用户类型:" class="form-item-usertype">
          <el-input
            :disabled="true"
            readonly
            class="custom-input txt-normalstyle width270"
            :value="showUserType"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="公司名称:"
          prop="user_remark_005"
          :rules="rules.user_remark_005"
        >
          <el-input
            class="custom-input width690"
            v-model="formData.user_remark_005"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item label="姓名:" prop="nick_name" :rules="rules.nick_name">
          <el-input
            class="custom-input width690"
            v-model="formData.nick_name"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="开发地:"
          prop="user_remark_007"
          :rules="rules.user_remark_007"
        >
          <CustomSelectCity
            class="width690"
            style="min-height: 46px"
            @changeLetter="handleChangeLetter"
            multiple
            v-model="formData.user_remark_007"
            placeholder="请选择"
            popper-class="customselect-popper"
            value-key="cityid"
          >
            <el-option
              v-for="(item, idx) in cityOptions"
              :key="idx"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </CustomSelectCity>
        </el-form-item>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="身份:"
          prop="user_remark_002"
          :rules="rules.user_remark_002"
        >
          <CustomSelect
            class="width690"
            style="min-height: 46px"
            :multiple-limit="3"
            multiple
            v-model="formData.user_remark_002"
            placeholder="请选择（最多3个）"
            popper-class="customselect-popper"
            value-key="value"
            otherValue="212"
          >
            <el-option
              v-for="(item, idx) in identityOptionsRegister"
              :key="idx"
              :label="item.text"
              :value="item"
              :remark="item.value"
            ></el-option>
          </CustomSelect>
        </el-form-item>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="团队人数:"
          prop="user_remark_006"
          :rules="rules.user_remark_006"
        >
          <el-input
            class="custom-input width690"
            v-model="formData.user_remark_006"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="行业:"
          prop="user_remark_008"
          :rules="rules.user_remark_008"
        >
          <CustomSelect
            class="width690"
            style="min-height: 46px"
            multiple
            v-model="formData.user_remark_008"
            placeholder="请选择"
            popper-class="customselect-popper"
            value-key="value"
            otherValue="810"
          >
            <el-option
              v-for="(item, idx) in industryOptions"
              :key="idx"
              :label="item.text"
              :value="item"
              :remark="item.value"
            >
            </el-option>
          </CustomSelect>
        </el-form-item>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="开发语言"
          prop="user_remark_003"
          :rules="rules.user_remark_003"
        >
          <CustomSelect
            class="width690"
            style="min-height: 46px"
            :multiple-limit="3"
            multiple
            v-model="formData.user_remark_003"
            placeholder="请选择"
            popper-class="customselect-popper"
            value-key="value"
            otherValue="329"
          >
            <el-option
              v-for="(item, idx) in devlangOptions"
              :key="idx"
              :label="item.text"
              :value="item"
              :remark="item.value"
            >
            </el-option>
          </CustomSelect>
        </el-form-item>
      </div>
      <div class="form-item form-item-normal">
        <el-form-item
          label="邮箱账号:"
          prop="user_email"
          :rules="rules.user_email"
        >
          <el-input
            class="custom-input width690"
            v-model="formData.user_email"
          ></el-input>
        </el-form-item>
      </div>
      <div class="bottom-buttons">
        <el-button
          class="custom-button btn-determine btn-modify"
          @click="handleConfirm"
          >确定并提交</el-button
        >
        <el-button
          class="custom-button btn-e0e0e0 btn-modify"
          @click="handleCancel"
          >取消</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import { phoneValidator, mailValidator, timeLoop } from "@/assets/js/util";
import CustomSelect from "@/components/CustomSelect.vue";
import CustomSelectCity from "@/components/CustomSelectCity.vue";
// import cityData from "@/utils/city";
import cityData from "@/utils/cityjs/developaddress";
import {
  identityOptionsRegister,
  developLangOptions,
  industryOptions,
  hotCites,
} from "@/assets/js/dictionary";
import lodash from "lodash";
import { hidePanCard } from "@/utils/tool";
import pageCommon from "@/utils/pagecommon";
import accountApi from "@/api/account";
export default {
  name: "BeSupplier",
  components: { CustomSelect, CustomSelectCity },
  created() {
    let _this = this;
    _this.cityOptions = _this.hotCites;
    _this.getUserInfo();
  },
  mounted() {
    let _this = this;
    // _this.$store.dispatch("acCenterNavIndex", 0);
  },
  data() {
    return {
      identityOptionsRegister: lodash.cloneDeep(identityOptionsRegister),
      devlangOptions: lodash.cloneDeep(developLangOptions),
      industryOptions: lodash.cloneDeep(industryOptions),
      origin_identityOptionsRegister: [],
      origin_devlangOptions: [],
      origin_industryOptions: [],
      hotCites: lodash.cloneDeep(hotCites),
      cityOptions: [],

      userType: 1,
      user: {
        id: 39877,
        userType: 1,
        identity: [],
        name: "aven",
        devlang: [],
        phone: "12313",
        pwd: "1212",
        mail: "1111",
        companyName: "111",
        developAddress: [],
        teamMember: 10,
        industry: [],
      },
      peopleModifyStatus: {
        identity: 0,
        name: 0,
        devlang: 0,
        mail: "",
      },
      supplierModifyStatus: {
        companyName: 0,
        identity: 0,
        name: 0,
        devlang: 0,
        mail: 0,
        developAddress: 0,
        teamMember: 0,
        industry: 0,
      },

      formData: {
        id_public_user_info: "",
        user_remark_001: "102",
        user_remark_002: [], //用户身份
        user_remark_005: "", //公司名称
        nick_name: "", //姓名
        user_remark_007: [], //开发地
        user_remark_006: "", //团队人数
        user_remark_008: [], //行业
        user_remark_003: [], //开发语言
        user_email: "",
      },
      orginFormData: {
        id_public_user_info: "",
        user_remark_001: "102",
        user_remark_002: [], //用户身份
        user_remark_005: "", //公司名称
        nick_name: "", //姓名
        user_remark_007: [], //开发地
        user_remark_006: "", //团队人数
        user_remark_008: [], //行业
        user_remark_003: [], //开发语言
        user_email: "",
      },
      templateFormData: {
        id_public_user_info: "",
        user_remark_001: "102",
        user_remark_002: [], //用户身份
        user_remark_005: "", //公司名称
        nick_name: "", //姓名
        user_remark_007: [], //开发地
        user_remark_006: "", //团队人数
        user_remark_008: [], //行业
        user_remark_003: [], //开发语言
        user_email: "",
      },
      rules: {
        user_remark_002: [
          { required: true, message: "选择身份", trigger: "change" },
          { required: true, message: "选择身份", trigger: "blur" },
        ],
        user_remark_003: [
          { required: true, message: "选择开发语言", trigger: "blur" },
        ],
        user_remark_005: [
          { required: true, message: "填写公司名称", trigger: "blur" },
        ],
        user_remark_006: [
          { required: true, message: "填写团队人数", trigger: "blur" },
        ],
        user_remark_007: [
          { required: true, message: "选择开发地", trigger: "change" },
        ],
        user_remark_008: [
          { required: true, message: "选择行业", trigger: "change" },
        ],
        nick_name: [{ required: true, message: "填写姓名", trigger: "blur" }],
        user_email: [
          { required: true, message: "填写邮箱", trigger: "blur" },
          { validator: mailValidator, trigger: "blur" },
        ],
        msg_content: [
          { required: true, message: "填写手机验证码", trigger: "blur" },
        ],
        pic_code: [{ required: true, message: "填写验证码", trigger: "blur" }],
        password_user: [
          { required: true, message: "填写密码", trigger: "blur" },
        ],
        user_phone: [
          { required: true, message: "填写正确的手机号码", trigger: "blur" },
          { validator: phoneValidator, trigger: "blur" },
        ],
      },
      isRequesting: false,
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
    showUserType: function () {
      let _this = this;
      if (!_this.formData) {
        return "";
      }
      if (_this.formData.user_remark_001 == 101) {
        return "个人";
      }
      if (_this.formData.user_remark_001 == 102) {
        return "服务商";
      }
      return "";
    },
    isSupplier: function () {
      let _this = this;
      if (!_this.formData) {
        return false;
      }
      if (_this.formData.user_remark_001 != 102) {
        return false;
      }
      return true;
      // return _this.$store.state.isSupplier;
    },
  },
  methods: {
    getUserInfo: function () {
      let _this = this;
      pageCommon
        .apiRequestCommon(accountApi, "getUserShopInfo", {
          isloading: true,
        })
        .then(
          (res) => {
            let formData = res.public_user_info;
            _this.dealWithFormData(formData);
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
    },
    // 作废其他跟斜杆青年身份
    filterSelect(data){
      var data_arr=[];
      if(data){
        data_arr=data.split(',');
        for (let i = data_arr.length - 1; i >= 0; i--) {
          if (data_arr[i] === '211' || data_arr[i] === '212') {
            data_arr.splice(i, 1);
          }
        }
      }
      return data_arr.join(',')
    },
    dealWithFormData: function (formData) {
      let _this = this;
      // 身份
      formData.user_remark_002=this.filterSelect(formData.user_remark_002);
      if (
        formData &&
        (formData.user_remark_002 ||
          formData.user_remark_002 === "0" ||
          formData.user_remark_002 === 0)
      ) {
        let user_remark_002_val = formData ? formData.user_remark_002 : "";
        let user_remark_009_val = formData ? formData.user_remark_009 : "";
        let user_remark_002 = _this.dealWithMultipleData(
          "identityOptionsRegister",
          user_remark_002_val,
          212,
          user_remark_009_val
        );
        formData.user_remark_002 = user_remark_002;
      } else if (formData) {
        formData.user_remark_002 = [];
      }

      // 开发语言
      if (
        formData &&
        (formData.user_remark_003 ||
          formData.user_remark_003 === "0" ||
          formData.user_remark_003 === 0)
      ) {
        let user_remark_003_val = formData ? formData.user_remark_003 : "";
        let user_remark_010_val = formData ? formData.user_remark_010 : "";
        let user_remark_003 = _this.dealWithMultipleData(
          "devlangOptions",
          user_remark_003_val,
          329,
          user_remark_010_val
        );
        formData.user_remark_003 = user_remark_003;
      } else if (formData) {
        formData.user_remark_003 = [];
      }
      //810
      if (
        formData &&
        (formData.user_remark_008 ||
          formData.user_remark_008 === "0" ||
          formData.user_remark_008 === 0)
      ) {
        let user_remark_008_val = formData ? formData.user_remark_008 : "";
        let user_remark_011_val = formData ? formData.user_remark_011 : "";
        let user_remark_008 = _this.dealWithMultipleData(
          "industryOptions",
          user_remark_008_val,
          810,
          user_remark_011_val
        );
        formData.user_remark_008 = user_remark_008;
      } else if (formData) {
        formData.user_remark_008 = [];
      }
      if (
        formData &&
        (formData.user_remark_007 ||
          formData.user_remark_007 === "0" ||
          formData.user_remark_007 === 0)
      ) {
        let user_remark_007_val = formData ? formData.user_remark_007 : "";
        let user_remark_007 =
          _this.dealWithDevlopAddressData(user_remark_007_val);
        formData.user_remark_007 = user_remark_007;
      } else if (formData) {
        formData.user_remark_007 = [];
      }
      _this.formData.user_remark_001 = "102";
      _this.formData = formData;
      _this.orginFormData = lodash.cloneDeep(formData);
    },
    dealWithMultipleData: function (
      listname,
      resdata,
      othervalue,
      other_remark_value
    ) {
      let _this = this;
      let arrRes = resdata ? resdata.split(",") : [];
      let selectedData = [];
      let list = _this[listname];
      for (let i = 0; i < arrRes.length; i++) {
        const tmpRes = arrRes[i];
        for (let j = 0; j < list.length; j++) {
          const tmpitem = list[j];
          if (tmpitem.value == tmpRes) {
            if (tmpitem.value == othervalue) {
              tmpitem.remark = other_remark_value;
            }
            selectedData.push(tmpitem);
          }
        }
      }
      _this[`origin_${listname}`] = lodash.cloneDeep(list);
      return selectedData;
    },
    dealWithDevlopAddressData: function (address) {
      let _this = this;
      let arrAddress = address ? address.split(",") : [];
      let selecteCities = [];
      for (let i = 0; i < arrAddress.length; i++) {
        const add = arrAddress[i];

        for (let j = 0; j < cityData.length; j++) {
          const city = cityData[j];
          if (city.cityid == add) {
            selecteCities.push(lodash.cloneDeep(city));
          }
        }
      }
      return selecteCities;
    },
    handleChangeLetter: function (idx) {
      let _this = this;
      let cityOptions = [];
      if (idx == -1) {
        cityOptions = _this.hotCites;
      } else {
        cityOptions = _this.getCityByIdx(idx);
      }
      _this.cityOptions = cityOptions;
    },
    getCityByIdx: function (idx) {
      let letters = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ];
      let cityOptions = [];
      for (let i = idx * 4; i < (idx + 1) * 4 && i < letters.length; i++) {
        const letter = letters[i];
        for (let j = 0; j < cityData.length; j++) {
          const city = cityData[j];
          if (city.tags.indexOf(letter) == 0) {
            cityOptions.push(city);
          }
        }
      }
      return cityOptions;
    },
    handleConfirm: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      this.$refs["basicsForm"].validate((valid) => {
        if (valid) {
          let changeData = _this.dealChangUserInfo();
          _this.changeUserInfoMain(changeData);
          _this.isRequesting = false;
          return;
        } else {
          _this.isRequesting = false;
          return;
        }
      });
      // _this.$refs['basicsForm'].validateField(prop, valid => {
      //   console.log(valid, "step");
      //   if (!valid) {
      //     let changeData = _this.dealChangUserInfo();
      //     _this.changeUserInfoMain(changeData, obj, prop);
      //     return
      //   }
      //   _this.isRequesting = false;
      // })
      // return;
      // _this.$store.dispatch("acIsSupplier", true)
      // _this.$router.go(-1);
    },
    dealChangUserInfo: function () {
      let _this = this;
      let user_remark_002_values = [];
      let user_remark_009 = "";
      if (
        _this.formData.user_remark_002 ||
        _this.formData.user_remark_002 === 0 ||
        _this.formData.user_remark_002 === "0"
      ) {
        for (let i = 0; i < _this.formData.user_remark_002.length; i++) {
          const element = _this.formData.user_remark_002[i];
          user_remark_002_values.push(element.value);
          if (element.value == "212") {
            user_remark_009 = element.remark;
          }
        }
      }

      let user_remark_003_values = [];
      let user_remark_010 = "";
      if (
        _this.formData.user_remark_003 ||
        _this.formData.user_remark_003 === 0 ||
        _this.formData.user_remark_003 === "0"
      ) {
        for (let i = 0; i < _this.formData.user_remark_003.length; i++) {
          const element = _this.formData.user_remark_003[i];
          user_remark_003_values.push(element.value);
          if (element.value == "329") {
            user_remark_010 = element.remark;
          }
        }
      }
      let user_remark_007_values = [];
      if (
        _this.formData.user_remark_007 ||
        _this.formData.user_remark_007 === 0 ||
        _this.formData.user_remark_007 === "0"
      ) {
        for (let i = 0; i < _this.formData.user_remark_007.length; i++) {
          const element = _this.formData.user_remark_007[i];
          user_remark_007_values.push(element.cityid);
        }
      }
      let user_remark_008_values = [];
      let user_remark_011 = "";
      if (
        _this.formData.user_remark_008 ||
        _this.formData.user_remark_008 === 0 ||
        _this.formData.user_remark_008 === "0"
      ) {
        for (let i = 0; i < _this.formData.user_remark_008.length; i++) {
          const element = _this.formData.user_remark_008[i];
          user_remark_008_values.push(element.value);
          if (element.value == "810") {
            user_remark_011 = element.remark;
          }
        }
      }
      let changeUserInfo = {
        id_public_user_info: _this.formData.id_public_user_info,
        nick_name: _this.formData.nick_name,
        user_remark_001: "102", //_this.formData.user_remark_001,
        user_remark_002: user_remark_002_values.join(","),
        user_remark_009: user_remark_009,
        user_remark_003: user_remark_003_values.join(","),
        user_remark_010: user_remark_010,
        user_remark_004: 401,
        user_remark_005: _this.formData.user_remark_005,
        user_remark_006: _this.formData.user_remark_006,
        user_remark_007: user_remark_007_values.join(","),
        user_remark_008: user_remark_008_values.join(","),
        user_remark_011: user_remark_011,
        user_email: _this.formData.user_email,
      };
      return changeUserInfo;
    },
    changeUserInfoMain: function (changeUerInfo) {
      let _this = this;
      let requestData = {
        id_public_user_info: changeUerInfo.id_public_user_info,
        nick_name: changeUerInfo.nick_name,
        user_remark_001: changeUerInfo.user_remark_001,
        user_remark_002: changeUerInfo.user_remark_002,
        user_remark_009: changeUerInfo.user_remark_009,
        user_remark_003: changeUerInfo.user_remark_003,
        user_remark_010: changeUerInfo.user_remark_010,
        user_remark_004: changeUerInfo.user_remark_004,
        user_remark_005: changeUerInfo.user_remark_005,
        user_remark_006: changeUerInfo.user_remark_006,
        user_remark_007: changeUerInfo.user_remark_007,
        user_remark_008: changeUerInfo.user_remark_008,
        user_remark_011: changeUerInfo.user_remark_011,
        user_email: changeUerInfo.user_email,
        isloading: false,
      };
      pageCommon
        .apiRequestCommon(accountApi, "changeUerInfo", requestData)
        .then(
          (res) => {
            _this.isRequesting = false;
            _this.$message.success("提交成功");
            _this.$store.dispatch("acUser", res.public_user_info);
            storage.set("user", JSON.stringify(res.public_user_info));
            _this.$router.go(-1);
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
    },
    handleCancel: function () {
      let _this = this;
      _this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.besupplier {
  margin-left: 40px;
  .width100per {
    width: 100%;
  }
  .title {
    font-size: 26px;
    font-family: "SourceHanSansCN";
    color: rgb(34, 34, 34);
    font-weight: bold;
    margin-top: 40px;
    text-align: left;
    .tip {
      font-size: 16px;
      font-family: "SourceHanSansCN";
      color: rgb(153, 153, 153);
    }
  }
  .myaccount-peopleform,
  .myaccount-supplierform {
    position: relative;
    margin-top: 40px;
    .form-item {
      width: 990px;
      display: flex;
      align-items: center;
      &.form-item-base {
        margin-bottom: 30px;
        .form-item-usertype {
          margin-left: 45px;
        }
      }
      &.form-item-normal {
        padding-top: 30px;
        padding-bottom: 8px;
        box-sizing: border-box;
        border-top: 1px solid rgb(238, 238, 238);
        .buttons {
          display: flex;
          align-items: center;
          // margin-left: 10px;
          .custom-button {
            margin-left: 10px;
            &:first-child {
              margin-left: 30px;
            }
          }
        }
      }

      /deep/.el-form-item__label {
        font-size: 16px;
        font-family: "SourceHanSansCN";
        color: rgba(153, 153, 153, 1);
      }
      .txt-normalstyle {
        height: 46px;
        line-height: 46px;

        font-size: 16px;
        font-family: "SourceHanSansCN";
        color: rgba(102, 102, 102, 1);
      }
      .width690 {
        width: 690px;
      }
      .width270 {
        width: 270px;
      }

      .btn-modify {
        width: 80px;
        height: 46px;
        line-height: 46px;
        font-size: 16px;
        // margin-left: 30px;
        margin-bottom: 22px;
      }
    }
    .bottom-buttons {
      display: flex;
      align-items: center;
      // justify-content: center;
      margin: 30px 325px;
      .custom-button {
        height: 46px;
        line-height: 46px;

        font-size: 16px;

        &:first-child {
          width: 110px;
          margin-left: 0;
        }
        &:last-child {
          width: 94px;
          margin-left: 40px;
        }
      }
    }

    .line {
      width: 100%;
      height: 1px;
      border-bottom: 1px solid rgb(238, 238, 238);
      margin: 30px 0;
      box-sizing: border-box;
    }
  }
}
</style>